import { useNavigate } from "react-router-dom";

function LegalNotice() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: "100vh", background: "#03070d", color: "white", padding: "70px 20px 40px" }}>
      <button onClick={() => navigate(
  new URLSearchParams(window.location.search).get("retour") === "assistance"
    ? "/assistance"
    : "/"
)} style={backBtn}>← Retour</button>

      <div style={card}>
        <h1 style={title}>Mentions légales</h1>

        <h2 style={sub}>Éditeur</h2>
        <p><strong>EVO-LIVE SAS</strong></p>
        <p>Société par actions simplifiée au capital de 50 €</p>
        <p>Société en cours d’immatriculation au RCS</p>
        <p>Responsable de la publication : EVO-LIVE</p>

        <h2 style={sub}>Contact</h2>
        <p style={link}>evo.contact@gmail.com</p>

        <h2 style={sub}>Hébergement</h2>
        <p>
          OVHcloud<br />
          2 rue Kellermann, 59100 Roubaix, France
        </p>

        <h2 style={sub}>Accès au service</h2>
        <p>
          EVO-LIVE propose une plateforme permettant la création, la diffusion et la consultation
          de contenus vidéo, stories, lives, messages et interactions sociales.
        </p>

        <h2 style={sub}>Propriété intellectuelle</h2>
        <p>
          Tous les éléments de la plateforme EVO-LIVE (logos, design, textes, interfaces,
          technologies) sont protégés par le droit de la propriété intellectuelle.
          Toute reproduction, modification ou exploitation sans autorisation est interdite.
        </p>

        <h2 style={sub}>Contenu utilisateur</h2>
        <p>
          Les utilisateurs sont seuls responsables des contenus qu’ils publient (vidéos, images,
          messages, lives, commentaires).
        </p>
        <p>
          Ils s’engagent à respecter les lois en vigueur et les droits des tiers (droit à l’image,
          propriété intellectuelle, vie privée).
        </p>
        <p>
          EVO-LIVE se réserve le droit de supprimer tout contenu non conforme sans préavis.
        </p>

        <h2 style={sub}>Modération et sanctions</h2>
        <p>
          EVO-LIVE peut, à tout moment :
        </p>
        <ul>
          <li>supprimer un contenu ;</li>
          <li>restreindre la visibilité d’une vidéo ;</li>
          <li>suspendre ou supprimer un compte ;</li>
          <li>interrompre un live ;</li>
        </ul>
        <p>
          Ces décisions peuvent être prises en cas de non-respect des règles, de signalement
          ou de comportement abusif.
        </p>

        <h2 style={sub}>Coins et éléments virtuels</h2>
        <p>
          Les coins et cadeaux proposés sur EVO-LIVE sont des éléments numériques sans valeur
          monétaire réelle en dehors de la plateforme.
        </p>
        <p>
          Ils ne peuvent pas être échangés contre de l’argent, sauf disposition spécifique prévue
          par EVO-LIVE.
        </p>

        <h2 style={sub}>Paiements</h2>
        <p>
          Les achats peuvent être réalisés via des plateformes tierces (Google Play, Apple App Store).
          EVO-LIVE n’est pas responsable des conditions propres à ces services.
        </p>

        <h2 style={sub}>Remboursements</h2>
        <p>
          Les achats de coins sont en principe non remboursables.
        </p>
        <p>
          En cas d’erreur technique ou de double paiement, une demande peut être effectuée
          via le support. Chaque demande est étudiée individuellement.
        </p>

        <h2 style={sub}>Responsabilité</h2>
        <p>
          EVO-LIVE met en œuvre tous les moyens raisonnables pour assurer le bon fonctionnement
          du service, mais ne garantit pas l’absence d’erreurs, d’interruptions ou de bugs.
        </p>
        <p>
          EVO-LIVE ne peut être tenu responsable :
        </p>
        <ul>
          <li>des contenus publiés par les utilisateurs ;</li>
          <li>des pertes de données ou de revenus ;</li>
          <li>des dysfonctionnements techniques temporaires ;</li>
          <li>de l’utilisation frauduleuse d’un compte.</li>
        </ul>

        <h2 style={sub}>Sécurité</h2>
        <p>
          L’utilisateur est responsable de la confidentialité de ses identifiants.
          Toute activité réalisée depuis son compte est réputée lui appartenir.
        </p>

        <h2 style={sub}>Données personnelles</h2>
        <p>
          Les données personnelles sont traitées conformément à la politique de confidentialité.
        </p>

        <h2 style={sub}>Loi applicable</h2>
        <p>
          Les présentes mentions légales sont soumises au droit français.
          En cas de litige, les tribunaux français seront compétents.
        </p>

        <p style={footer}>EVO-LIVE SAS – Tous droits réservés</p>
      </div>
    </div>
  );
}

const backBtn = {
  position: "fixed",
  top: 20,
  left: 20,
  zIndex: 9999,
  border: "1px solid rgba(0,242,255,0.55)",
  background: "rgba(0, 12, 20, 0.9)",
  color: "#00f2ff",
  padding: "10px 16px",
  borderRadius: 999,
  fontWeight: "bold",
  cursor: "pointer",
  boxShadow: "0 0 18px rgba(0,242,255,0.35)",
};

const card = {
  maxWidth: 900,
  margin: "auto",
  padding: "32px 24px",
  borderRadius: 26,
  background: "rgba(0, 12, 20, 0.82)",
  border: "1px solid rgba(0,242,255,0.28)",
  boxShadow: "0 0 35px rgba(0,242,255,0.14)",
  lineHeight: 1.7,
};

const title = {
  color: "#00f2ff",
  marginBottom: 25,
  textShadow: "0 0 18px rgba(0,242,255,0.6)",
};

const sub = {
  color: "#00f2ff",
  marginTop: 28,
};

const link = {
  color: "#00f2ff",
  fontWeight: "bold",
};

const footer = {
  marginTop: 40,
  fontSize: 12,
  opacity: 0.7,
};

export default LegalNotice;